var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuBillingReport = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  baseProfile: "tiny",
  id: "BillingReport",
  x: "0px",
  y: "0px",
  viewBox: "0 0 24 24",
  overflow: "visible",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "#FFFFFF",
  d: "M12.39,10.9c2.27,0.59,4.7,1.56,4.7,4.4c0,2.05-1.55,3.18-3.5,3.55V21h-3v-2.17 C8.67,18.42,7.03,17.19,6.91,15h2.2c0.11,1.18,0.92,2.1,2.98,2.1c2.21,0,2.7-1.1,2.7-1.79c0-0.93-0.5-1.81-3-2.41 c-2.79-0.67-4.7-1.82-4.7-4.13c0-1.93,1.56-3.19,3.5-3.61V3h3v2.19C15.68,5.7,16.73,7.28,16.8,9h-2.21c-0.06-1.25-0.72-2.1-2.5-2.1 c-1.69,0-2.7,0.76-2.7,1.85C9.39,9.7,10.12,10.31,12.39,10.9z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuBillingReport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_BillingReport.58c39357.svg";
export { ForwardRef as ReactComponent };